module.exports = __webpack_public_path__ + "img/suffrage-pins.418b6caa.png";